import type { TableBodyProps as MuiTableBodyProps } from '@mui/material';
import { TableBody as MuiTableBody } from '@mui/material';

/**
 * <p>
 * Based on MUI TableBody: https://mui.com/material-ui/api/table-body/
 * </p>
 * */
export const TableBody = (props: MuiTableBodyProps) => <MuiTableBody {...props} />;
